import React from "react";
import { Box } from "@chakra-ui/react";

export function GlobeIcon() {
  return (
    <Box as="svg" xmlns="http://www.w3.org/2000/svg" boxSize={12} viewBox="0 0 256 256">
      <path fill="none" d="M0 0h256v256H0z" />
      <Box
        as="path"
        fill="new.blue.150"
        d="M130.2 224a96.3 96.3 0 0 0 84-53.6L159.9 137a7.2 7.2 0 0 0-3.1-1.1l-22.9-3.1a7.8 7.8 0 0 0-8.3 4.7l-13.7 30.7a8 8 0 0 0 1.4 8.7l18.8 20.3a8.2 8.2 0 0 1 2 7l-3.9 19.8ZM65 55.6l-9 21.2a8 8 0 0 0-.1 5.9l11.5 30.6a7.9 7.9 0 0 0 5.8 5.1l5.4 1.1 8.3-19.7a8.1 8.1 0 0 1 7.4-4.9h21.4a8.6 8.6 0 0 0 3.8-1l12.3-6.8a7.2 7.2 0 0 0 1.5-1.1l26.9-24.3a8.1 8.1 0 0 0 1.6-9.8l-9.3-16.8A98.5 98.5 0 0 0 128 32a95.4 95.4 0 0 0-63 23.6Z"
      />
      <Box
        as="circle"
        cx={128}
        cy={128}
        r={96}
        fill="none"
        stroke="new.blue.500"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={14}
      />
      <Box
        as="path"
        d="M214.2 170.4 159.9 137a7.2 7.2 0 0 0-3.1-1.1l-22.9-3.1a7.8 7.8 0 0 0-8.3 4.7l-13.7 30.7a8 8 0 0 0 1.4 8.7l18.8 20.3a8.2 8.2 0 0 1 2 7l-3.9 19.8"
        fill="none"
        stroke="new.blue.500"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={14}
      />
      <Box
        as="path"
        d="m65 55.6-9 21.2a8 8 0 0 0-.1 5.9l11.5 30.6a7.9 7.9 0 0 0 5.8 5.1l21.4 4.6a7.8 7.8 0 0 1 5.5 4.3l3.8 7.9a8.2 8.2 0 0 0 7.2 4.5h13.5"
        fill="none"
        stroke="new.blue.500"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={14}
      />
      <Box
        as="path"
        d="m152.5 35.1 9.3 16.8a8.1 8.1 0 0 1-1.6 9.8L133.3 86a7.2 7.2 0 0 1-1.5 1.1l-12.3 6.8a8.6 8.6 0 0 1-3.8 1H94.3a8.1 8.1 0 0 0-7.4 4.9l-8.3 19.7"
        fill="none"
        stroke="new.blue.500"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={14}
      />
    </Box>
  );
}
